import React, { Fragment, useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Typography, Grid } from "@mui/material";
import { LazyLoadImage } from "react-lazy-load-image-component";
import principal from "../../images/preguntas.png";
/* import principal from "../../images/imagen_faq.gif";*/
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";

import { withStyles } from "@mui/styles";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  padding: "10px 0",

  "&:last-child": {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },

  marginRight: theme.spacing(3),
  "&:before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor: "rgba(255, 255, 255, .05)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const styles = (theme) => ({
  wrapper: {
    minHeight: "100vh",
    marginTop: "150px",
    background: "#fff",
    maxWidth: "1200px",
    marginLeft: "auto",
    marginRight: "auto",

    [theme.breakpoints.up("sm")]: {
      paddingLeft: "24px",
      paddingRight: "24px",
    },

    [theme.breakpoints.down("sm")]: {
      paddingLeft: "24px",
      paddingRight: "24px",
    },
  },

  titulo: {
    fontSize: "4rem !important",
    lineHeight: "1.25 !important",
    fontWeight: "700 !important",
    marginTop: "20px !important",

    marginBottom: "40px !important",
    [theme.breakpoints.down("md")]: {
      fontSize: "3rem !important",
    },
  },

  subtitulos: {
    lineHeight: "1.75 !important",
    fontWeight: "400 !important",
    fontSize: "1rem !important",
  },

  container: {
    marginTop: theme.spacing(6),
  },
});

function Faqs(props) {
  const { classes, theme, width, errors, inicio, messages } = props;
  const [expanded, setExpanded] = React.useState("");

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <Fragment>
      <div
        className={classNames("lg-p-top crossfade", classes.wrapper)}
        ref={inicio}
      >
        <Grid container spacing={12}>
          <Grid item xs={12} md={6} lg={7}>
            <Typography variant="overline" display="block" gutterBottom>
              FAQS
            </Typography>

            <Typography align="center" className={classes.titulo}>
              {messages.faq_faq}
            </Typography>
            <Accordion
              expanded={expanded === "panel1"}
              onChange={handleChange("panel1")}
            >
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Typography sx={{ fontWeight: "bold" }}>
                  {messages.pregunta_1}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>{messages.respuesta_1}</Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expanded === "panel2"}
              onChange={handleChange("panel2")}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography sx={{ fontWeight: "bold" }}>
                  {messages.pregunta_2}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>{messages.respuesta_2}</Typography>
              </AccordionDetails>
            </Accordion>
            <Accordion
              expanded={expanded === "panel3"}
              onChange={handleChange("panel3")}
            >
              <AccordionSummary
                aria-controls="panel3d-content"
                id="panel3d-header"
              >
                <Typography sx={{ fontWeight: "bold" }}>
                  {messages.pregunta_3}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>{messages.respuesta_3}</Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel4"}
              onChange={handleChange("panel4")}
            >
              <AccordionSummary
                aria-controls="panel4d-content"
                id="panel4d-header"
              >
                <Typography sx={{ fontWeight: "bold" }}>
                  {messages.pregunta_4}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  {React.createElement("div", {
                    dangerouslySetInnerHTML: {
                      __html: messages.respuesta_4,
                    },
                  })}
                </Typography>
              </AccordionDetails>
            </Accordion>

            <Accordion
              expanded={expanded === "panel5"}
              onChange={handleChange("panel5")}
            >
              <AccordionSummary
                aria-controls="panel5d-content"
                id="panel5d-header"
              >
                <Typography sx={{ fontWeight: "bold" }}>
                  {messages.pregunta_5}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  {React.createElement("div", {
                    dangerouslySetInnerHTML: {
                      __html: messages.respuesta_5,
                    },
                  })}
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            lg={5}
            sx={{ paddingLeft: "5px", paddingTop: "20px" }}
          >
            <LazyLoadImage
              alt="Preguntas precuentes"
              src={principal} // use normal <img> attributes as props
              width="105%"
              effect="opacity"
              delayMethod="debounce"
            />
          </Grid>
        </Grid>
      </div>
    </Fragment>
  );
}

Faqs.propTypes = {
  classes: PropTypes.object,
  errors: PropTypes.object.isRequired,
  inicio: PropTypes.object.isRequired,
  width: PropTypes.string,
  theme: PropTypes.object,
  messages: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Faqs);
